/* eslint no-underscore-dangle: 0 */
import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-toolbox/lib/button';
import { list } from '~/actions/actions';
import Action from '~/components/Action';

import style from './style.scss';

class Actions extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
    router: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    list(this.props.dispatch, this.context.apiClient);
  }

  render() {
    const results = Object.keys(this.props.items);
    return (
      <div style={{ padding: '10px' }}>
        <div className={style.title}>Actions</div>
        <Button
          label="New Action"
          onClick={() => this.context.dialogPush('actionNew')}
          primary
          raised
          className={style.buttonNew}
          icon="add"
        />
        {results.map(i => <Action key={i} id={i} style={{ margin: '5px 5px 0px 0px' }} />)}
        {results.length === 0 && <div>No actions found</div>}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  items: state.getIn(['actions', 'items']).toJS(),
});

export default connect(mapStateToProps)(Actions);



// WEBPACK FOOTER //
// ./app/pages/Actions/index.js